import React from "react";
import "./dropDownHL.css";
import { Grid } from "@material-ui/core";
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const DropDownBtnHLPure = (props) => {
  const {
    labelDropDown, //Label text to dropDown
    optionsDropDown, //Array to options
    onDropDownChange, //onChange function to change options and select value
    optionsValue, //Value
    valueItem, //Default value from array
    nameOption, //Value option
    flex, //True active style flex container
    tooltipShow, //True or false to show tooltip
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    titleTooltip, //Title tooltip string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description optional
    restContent, //More text to tooltip description optional
    informationIcon, // Choose the information icon true or false to custom img
    disable, // True or False to disable
    required,
  } = props;

  return (
    <Grid
      xs={12}
      lg={12}
      md={12}
      sm={12}
      className={
        flex === true
          ? "dropDownBtnHLPure-containerFlex"
          : "dropDownBtnHLPure-container"
      }
    >
      <Grid
        item
        className={
          flex === true
            ? "dropDownBtnHLPure-container-textFlex"
            : "dropDownBtnHLPure-container-text"
        }
      >
        <label className="dropDownBtnHLPure-label" for={optionsValue}>
          {labelDropDown} {required && "*"}
        </label>
        {tooltipShow ? (
          <TooltipHLPure
            positionTooltip={positionTooltip}
            titleTooltip={titleTooltip}
            descriptionTooltip={descriptionTooltip}
            subContent={subContent}
            restContent={restContent}
            informationIcon={informationIcon}
          />
        ) : (
          ""
        )}
      </Grid>
      <div className="dropDownBtnHLPure-select-wrapper">
        <select
          className="dropDownBtnHLPure-select"
          onChange={onDropDownChange}
          id={optionsValue}
          disabled={disable}
          required={required}
        >
          {optionsDropDown.map((arrayItem, index) => (
            <option
              value={valueItem !== "" ? arrayItem[valueItem] : arrayItem}
              key={index}
              selected={arrayItem[valueItem] === optionsValue ? true : false}
            >
              {(arrayItem[nameOption]) || arrayItem}
            </option>
          ))}
        </select>
      </div>
    </Grid>
  );
};

export { DropDownBtnHLPure as default };
